export const BoardType = Object.freeze({
    Default: 0,
    Enterprise: 1,
    'Referral Partner': 2,
    'Cross Organization': 3
})

export const TagType = Object.freeze({
    Default: 0,
    'Default Participant': 1,
    Custom: 2
})

export const TopicStatus = Object.freeze({
    Active: 0,
    Completed: 1,
    Archived: 2
})

export const Actions = Object.freeze({
    Add: 0,
    Edit: 1,
    View: 2
})

export const Ascending = true

export const TopicStatusChange = Object.freeze({
    'Admins & Authors': 0,
    Anyone: 1
})